export const SECTION_TITLE = 'sectionTitle';
export const SECTION_INTRO = 'sectionIntro';
export const CALENDAR_TYPE = 'calendarType';
export const ICAL_URL = 'icalURL';
export const TIMEZONE = 'timezone';
export const EVENTS = 'events';
export const EVENTS_DATE = `${EVENTS}.date`;
export const EVENTS_TITLE = `${EVENTS}.title`;
export const EVENTS_DESC = `${EVENTS}.desc`;
export const EVENTS_ALL_DAY = `${EVENTS}.allDay`;
export const EVENTS_START = `${EVENTS}.start`;
export const EVENTS_END = `${EVENTS}.end`;
export const EVENTS_LOCATION = `${EVENTS}.location`;
export const RENDER_MODE = 'renderMode';
export const ACCOUNT_ID = 'accountId';
export const LOCALE = 'locale';
export const ENV = 'env';
export const IS_FACEBOOK_CALENDAR = 'isFacebookCalendar';
